/**
 * Truncate a string if it's too long
 * @param {string} string - input string
 * @param {number} limit - limit to start truncating the text
 * @param {string} postfix - postfix to append to the truncated string
 * @returns {*}
 */
export default function truncate(string, limit, postfix = '...') {
    if (limit && string.length > limit) {
        return `${ string.substr(0, limit).trim() }${ postfix }`;
    }

    return string;
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/misc/truncate.js